import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';

export let updateGmailIsConnecting = mutatorAction(
    'updateGmailIsConnecting',
    (isConnecting: boolean) => {
        let store = connectedAccountsStore();
        store.connectGmailState.isConnecting = isConnecting;
    }
);
